module.exports = __webpack_public_path__ + "static/media/glutenfree.ff7ae05d.svg";